var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd2White(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 22.4035C6.29555 22.4035 1.65527 17.7632 1.65527 12.0587C1.65527 6.35414 6.29555 1.71387 12.0001 1.71387C17.7047 1.71387 22.3449 6.35414 22.3449 12.0587C22.3449 17.7632 17.7047 22.4035 12.0001 22.4035ZM12.0001 3.36904C7.20838 3.36904 3.31045 7.26697 3.31045 12.0587C3.31045 16.8504 7.20838 20.7484 12.0001 20.7484C16.7918 20.7484 20.6898 16.8496 20.6898 12.0587C20.6898 7.2678 16.7918 3.36904 12.0001 3.36904ZM11.9999 17.8518C11.7805 17.8518 11.57 17.7646 11.4148 17.6094C11.2596 17.4542 11.1724 17.2437 11.1724 17.0242V12.8861H7.03462C6.81513 12.8861 6.60463 12.7989 6.44943 12.6437C6.29422 12.4885 6.20703 12.278 6.20703 12.0585C6.20703 11.8391 6.29422 11.6286 6.44943 11.4734C6.60463 11.3181 6.81513 11.231 7.03462 11.231H11.1724V7.09321C11.1724 6.87372 11.2596 6.66322 11.4148 6.50802C11.57 6.35282 11.7805 6.26562 11.9999 6.26562C12.2194 6.26562 12.4299 6.35282 12.5851 6.50802C12.7403 6.66322 12.8275 6.87372 12.8275 7.09321V11.231H16.9657C17.1851 11.231 17.3956 11.3181 17.5508 11.4734C17.706 11.6286 17.7932 11.8391 17.7932 12.0585C17.7932 12.278 17.706 12.4885 17.5508 12.6437C17.3956 12.7989 17.1851 12.8861 16.9657 12.8861H12.8275V17.0242C12.8275 17.2437 12.7403 17.4542 12.5851 17.6094C12.4299 17.7646 12.2194 17.8518 11.9999 17.8518Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd2White);
export default __webpack_public_path__ + "static/media/Add-2-white.700d595bafd6dff081a52bf988070c3d.svg";
export { ForwardRef as ReactComponent };